import { LayoutNodeDto } from '../types';
import ApplicationDefinitionConditionalHelper from './ApplicationDefinitionConditionalHelper';

export const defaultChildBindingGroup = (node: LayoutNodeDto, instanceNumber: number) => ({
    bindingGroupId:
        node.count === 1
            ? node.id
            : `${node.id}${ApplicationDefinitionConditionalHelper.BindingGroupIdDelimiter}${instanceNumber}`,
    name: node.count === 1 ? node.name : `${node.name} ${instanceNumber}`
});
